import { COLORS } from './Paymenthistoryconstants';

export const getPaymentHistoryStyles = () => `
  .payment-history-modern .table thead tr { 
    background-color: #f9f9f9; 
  }
  
  .payment-history-modern .table th { 
    border: 0; 
    color: #6c757d; 
    font-weight: 600; 
  }
  
  .payment-history-modern .table td { 
    vertical-align: middle; 
  }
  
  .payment-history-modern .table-hover tbody tr:hover { 
    background: #fcfcfd; 
  }
  
  .payment-history-modern .search-input { 
    width: 260px; 
  }
  
  .payment-history-modern .header-actions { 
    gap: .5rem; 
  }
  
  .payment-history-modern .btn-rounded { 
    border-radius: 999px; 
  }
  
  .payment-history-modern .btn-navy { 
    background: ${COLORS.NAVY}; 
    border-color: ${COLORS.NAVY}; 
    color: #fff; 
  }
  
  .payment-history-modern .btn-navy:hover { 
    filter: brightness(1.03); 
  }
  
  .payment-history-modern .btn-orange { 
    background: ${COLORS.ORANGE}; 
    border-color: ${COLORS.ORANGE}; 
    color: #fff; 
  }
  
  .payment-history-modern .btn-orange:hover { 
    filter: brightness(1.03); 
  }
  
  .payment-history-modern .action-btn { 
    border-radius: 999px; 
    padding: .35rem .6rem; 
  }
  
  .payment-history-modern .pill-input, 
  .payment-history-modern .pill-select { 
    border-radius: 999px !important; 
    padding: .45rem .9rem; 
  }

  .payment-history-modern .corporate-pagination .page-link { 
    color: ${COLORS.NAVY}; 
    border-color: ${COLORS.ORANGE}; 
  }
  
  .payment-history-modern .corporate-pagination .page-item.active .page-link { 
    background-color: ${COLORS.NAVY}; 
    border-color: ${COLORS.NAVY}; 
    color: #fff; 
  }
  
  .payment-history-modern .corporate-pagination .page-link:hover { 
    border-color: ${COLORS.NAVY}; 
    color: ${COLORS.NAVY}; 
  }
  
  .payment-history-modern .mini-stat-card {
    display: flex;
    align-items: center;
    gap: 0.9rem;
    border: 1px solid #e9ecef;
    border-radius: 1rem;
    padding: 1.1rem 1.25rem;
    min-height: 95px;
    background: #fff;
    box-shadow: 0 1px 2px rgba(0,0,0,.04);
    transition: all .2s ease;
  }
  
  .payment-history-modern .mini-stat-card:hover {
    box-shadow: 0 2px 4px rgba(0,0,0,.08);
  }
  
  .payment-history-modern .mini-stat-amount {
    font-weight: 700;
    font-size: 1.3rem;
    line-height: 1.25;
  }

  .payment-history-modern .mini-stat-icon {
    width: 44px;
    height: 44px;
    flex: 0 0 44px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.4rem;
  }
  
  .payment-history-modern .mini-stat-icon.success { 
    background: #e6f6ec; 
  }
  
  .payment-history-modern .mini-stat-icon.pending { 
    background: #fff6e6; 
  }
  
  .payment-history-modern .mini-stat-icon.failed { 
    background: #fdecea; 
  }
  
  .payment-history-modern .stat-blur { 
    filter: blur(1px); 
    opacity: 0.55; 
  }
  
  .payment-history-modern .status-badge {
    border-radius: 999px;
    font-weight: 600;
    padding: 0.4rem 0.8rem;
    font-size: 12px;
  }

  .payment-history-modern .table-card {
    border-radius: 1rem;
    border: 0;
    box-shadow: 0 0.5rem 1.25rem rgba(10, 49, 110, 0.08);
  }

  @media (max-width: 576px) {
    .payment-history-modern .search-input { 
      width: 100%; 
    }
    
    .payment-history-modern .table { 
      font-size: 12px; 
    }
    
    .payment-history-modern .table td, 
    .payment-history-modern .table th { 
      padding: 0.5rem; 
    }
    
    .payment-history-modern .mini-stat-card {
      padding: 0.5rem 0.75rem;
    }
    
    .payment-history-modern .mini-stat-amount {
      font-size: 0.95rem;
    }
    
    .payment-history-modern .action-btn {
      padding: 0.25rem 0.4rem;
      font-size: 0.85rem;
    }
    
     .payment-history-modern .chip{
    display:inline-flex;align-items:center;gap:.35rem;
    padding:.28rem .6rem;border-radius:999px;font-weight:600;
    font-size:12px;border:0
  }
  .payment-history-modern .chip-navy{
    background:#E7EEF8;color:${COLORS.NAVY};
  }
  .payment-history-modern .chip-navy-solid{
    background:${COLORS.NAVY};color:#fff;
  }
  .payment-history-modern .chip-orange-solid{
    background:${COLORS.ORANGE};color:#fff;
  }
  .payment-history-modern .chip-green{
    background:#E8F6DB;color:#2E7D32;
  }
  .payment-history-modern .chip-amber{
    background:#FFF3CD;color:#8A6D3B;
  }
  .payment-history-modern .chip-red{
    background:#FDE2E2;color:#B42318;
  }
  .payment-history-modern .chip-gray{
    background:#ECEFF3;color:#4B5563;
  }

  /* Kurumsal buton varyantları */
  .payment-history-modern .btn-navy{ background:${COLORS.NAVY};border-color:${COLORS.NAVY};color:#fff; }
  .payment-history-modern .btn-navy-outline{ background:#fff;border-color:${COLORS.NAVY};color:${COLORS.NAVY}; }
  .payment-history-modern .btn-orange{ background:${COLORS.ORANGE};border-color:${COLORS.ORANGE};color:#fff; }
  .payment-history-modern .btn-orange-outline{ background:#fff;border-color:${COLORS.ORANGE};color:${COLORS.ORANGE}; }
  }

  /* Satır işlem menüsü: yalnızca lacivert üç çizgi — zemin/çerçeve yok.
     !important şart: reactstrap DropdownToggle varsayılan olarak .btn-secondary
     sınıfını basıyor; custom.css onu lacivert dolgu + 999px yarıçap + turuncu
     hover ile "!important" olarak sabitliyor. Zemini kaldırmak, köşeyi
     yumuşatmak ve hover'ı sakinleştirmek ancak aynı ağırlıkla mümkün.
     Kare ölçü + flex ortalama: ikon-only butonda Bootstrap'ın yatay padding'i
     çizgileri optik olarak sola kaydırıyordu.
     Not: yukarıdaki buton varyantları @media(max-width:576px) içinde kalmış;
     bu kural bilinçli olarak medya sorgusunun DIŞINDA, her ekranda geçerli. */
  .payment-history-modern .btn-actions-menu{
    background:transparent !important;
    border-color:transparent !important;
    color:${COLORS.NAVY} !important;
    box-shadow:none !important;
    border-radius:7px !important;
    width:30px; height:30px; padding:0 !important;
    display:inline-flex; align-items:center; justify-content:center;
  }
  /* Hover/açık durumda yalnızca çok hafif bir vurgu; dolgu rengi yok. */
  .payment-history-modern .btn-actions-menu:hover,
  .payment-history-modern .btn-actions-menu:focus,
  .payment-history-modern .btn-actions-menu.show{
    background:#EEF2F8 !important;
    border-color:transparent !important;
    color:${COLORS.NAVY} !important;
    box-shadow:none !important;
  }
  /* Boxicons glifi satır-içi kutuda taban çizgisine oturuyor; blok yapıp
     line-height'ı sıfırlayınca butonun tam merkezine geliyor. */
  .payment-history-modern .btn-actions-menu .bx{
    display:block; line-height:1; font-size:1.05rem;
  }

    /* Page size (Sayfa başına) — CompaniesTable ile uyumlu */
  .payment-history-modern .page-size-wrap{
    display:flex;align-items:center;gap:.5rem;white-space:nowrap;
  }
  .payment-history-modern .page-size-select{
    min-width:70px; padding-right:1.75rem; /* ok ikonu için nefes */
    border-radius:999px !important; /* rounded-pill ile eş */
  }
  .payment-history-modern .page-size-wrap .text-muted{
    font-size:.9rem;
  }

  @media (max-width:576px){
    .payment-history-modern .page-size-wrap{
      gap:.35rem;
    }
    .payment-history-modern .page-size-select{
      min-width:64px;
    }
  }
  .payment-history-modern .chip{
    display:inline-flex;
    align-items:center;
    gap:.35rem;
    padding:.3rem .7rem;
    border-radius:999px;
    font-weight:600;
    font-size:12px;
    border:0;
  }

  .payment-history-modern .chip-green{
    background:#E8F6DB;
    color:#2E7D32;
  }

  .payment-history-modern .chip-orange{
    background:#FFF3CD;
    color:#8A6D3B;
  }

  .payment-history-modern .chip-red{
    background:#FDE2E2;
    color:#B42318;
  }

  .payment-history-modern .chip-blue{
    background:#E7EEF8;
    color:${COLORS.NAVY};
  }

  .payment-history-modern .chip-gray{
    background:#ECEFF3;
    color:#4B5563;
  }

  /* hover efekti için */
  .payment-history-modern .chip:hover{
    filter:brightness(1.03);
  }
  
    /* --- Ödeme Tipi Chip'leri (Kurumsal) --- */
  .payment-history-modern .chip{
    display:inline-flex;
    align-items:center;
    gap:.35rem;
    padding:.32rem .7rem;
    border-radius:999px;
    font-weight:600;
    font-size:12px;
    border:0;
  }

  .payment-history-modern .chip-navy{
    background:#E7EEF8;
    color:${COLORS.NAVY};
  }

  .payment-history-modern .chip-orange{
    background:#FFF1E0;
    color:${COLORS.ORANGE};
  }

  /* Dolu versiyonlar (solid) */
  .payment-history-modern .chip-navy-solid{
    background:${COLORS.NAVY};
    color:#fff;
  }

  .payment-history-modern .chip-orange-solid{
    background:${COLORS.ORANGE};
    color:#fff;
  }

  .payment-history-modern .chip:hover{
    filter:brightness(1.03);
  }
  
  .chip-amber {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 500;
  display: inline-block;
}

  /* --- Özet kartları: 4'lü grid --- */
  .payment-history-modern .mini-stat-card{ height:100%; }
  .payment-history-modern .mini-stat-icon.total{ background:#E7EEF8; }
  .payment-history-modern .mini-stat-icon.total i{ color:${COLORS.NAVY}; }

  /* --- Filtre bloğu --- */
  .payment-history-modern .filter-bar{
    background:#fbfcfe;
    border:1px solid #eef1f5;
    border-radius:1rem;
    padding:1.15rem 1.25rem;
  }
  .payment-history-modern .filter-field{ min-width:180px; flex:1 1 180px; }
  .payment-history-modern .filter-label{
    font-size:.72rem; color:#8a94a6; font-weight:600;
    text-transform:uppercase; letter-spacing:.02em; margin-bottom:.3rem; display:block;
  }
  /* Referanstaki alan yüksekliği (~40px) */
  .payment-history-modern .filter-bar .pill-input,
  .payment-history-modern .filter-bar .pill-select{
    height:40px; padding-top:.4rem; padding-bottom:.4rem;
  }
  .payment-history-modern .filter-actions .btn{ height:40px; padding-inline:1.25rem; }
  .payment-history-modern .toolbar-actions .btn{ height:38px; padding-inline:1rem; }

  /* --- Tablo satır seçimi --- */
  .payment-history-modern .table tbody tr.row-clickable{ cursor:pointer; }
  .payment-history-modern .table tbody td{ padding-top:.85rem; padding-bottom:.85rem; }
  /* Seçili satır kalıcı olarak vurgulu kalır. Bootstrap 5 hover/stripe rengini
     hücrelere (tr > *) uyguladığı için arka planı satır yerine hücrelere veriyoruz;
     aksi halde tr üzerindeki renk hover bittiğinde beyaza dönüyor. */
  .payment-history-modern .table tbody tr.row-selected > *{
    background-color:#eceff3 !important;
    --bs-table-bg-state:#eceff3;
  }
  .payment-history-modern .table tbody tr.row-selected:hover > *{
    background-color:#e2e7ee !important;
    --bs-table-bg-state:#e2e7ee;
  }
  .payment-history-modern .table tbody tr.row-selected > *:first-child{
    box-shadow: inset 3px 0 0 ${COLORS.NAVY};
  }
  .payment-history-modern .cell-sub{ color:#8a94a6; font-size:.78rem; }
  /* Başarısız satırın gerekçesi Durum sütununu genişletip tabloyu dengesiz yapmasın. */
  .payment-history-modern .status-reason{ max-width:200px; margin:2px auto 0; }
  .payment-history-modern .table .chip{ white-space:nowrap; }

  /* --- Hızlı dönem düğmeleri (Bugün / Bu Hafta / Bu Ay) --- */
  /* Hover rengi inline stille verilemediği için sınıf kullanılıyor. */
  .payment-history-modern .period-pill{
    border-radius:999px; border:none; background:transparent;
    font-size:.8rem; font-weight:600; color:#6c757d;
    transition:background .15s ease, color .15s ease;
  }
  .payment-history-modern .period-pill:hover,
  .payment-history-modern .period-pill:focus-visible{
    background:${COLORS.ORANGE}; color:#fff;
  }
  .payment-history-modern .period-pill.is-active{
    background:${COLORS.NAVY}; color:#fff;
  }
  /* Seçili düğmede hover "kaldır" anlamına gelir; yine turuncuya döner. */
  .payment-history-modern .period-pill.is-active:hover{
    background:${COLORS.ORANGE}; color:#fff;
  }

  /* --- Detay paneli: masaüstünde içeriği daraltan sütun --- */
  /* Tema .main-content'e overflow:hidden veriyor (_vertical.scss); bu, içindeki
     position:sticky'yi tamamen devre dışı bırakıyor. Yatay kırpmayı koruyup
     dikeyde sticky'nin çalışması için yalnızca bu sayfada overflow-x:clip'e çeviriyoruz.
     Sınıf body'ye mount sırasında eklenir; daha önce kullanılan :has() tabanlı seçici
     her stil yeniden hesabında değerlendirildiği için takılmaya yol açıyordu —
     Link ile Ödeme ekranında da aynı nedenle body sınıfına geçilmişti. */
  body.payment-history-modern-page .main-content{
    overflow-x: clip;
    overflow-y: visible;
  }

  /* Kolon GENİŞLİĞİNE transition verilmez: panel ilk açılışta ana kolon hâlâ
     %100'den küçülürken mount olduğundan satıra sığmayıp tablonun ALTINA
     düşüyor, animasyon bitince sağa zıplıyordu. Kolonlar anında yerine oturur;
     açılış hissi panelin kendi fade/slide animasyonuyla verilir. */
  @keyframes phPdPanelIn{
    from{ opacity:0; transform:translateX(14px); }
    to{ opacity:1; transform:none; }
  }

  /* Panel akışta duran normal bir kart: boyu içeriği kadar, iç kaydırma yok.
     Özet kartlar satırın dışına alındığı için panel doğrudan tablonun hizasından
     başlar ve altta tabloyla birlikte biter. Sabit yükseklik/sticky KULLANILMIYOR:
     ikisi de paneli ya footer'a bindiriyor ya sol karttan farklı yerde bitiriyordu.
     modernTableStyles.js (Ödeme Linkleri + POS Rapor) ile birebir aynı. */
  .payment-history-modern .pd-panel{
    background:#fff;
    border:0;
    border-radius:1rem;
    box-shadow:0 .5rem 1.25rem rgba(10,49,110,.08);
    height:auto;
    display:flex;
    flex-direction:column;
    overflow:visible;
    animation: phPdPanelIn .18s ease-out;
  }
  .payment-history-modern .pd-panel-header{
    flex:0 0 auto;
    display:flex; align-items:center; justify-content:space-between;
    padding:1rem 1.15rem; border-bottom:1px solid #eef1f5;
  }
  /* Panel akışta ve içeriği kadar olduğu için iç kaydırma yok. */
  .payment-history-modern .pd-panel-body{ flex:1 1 auto; padding:1.15rem; overflow-y:visible; }
  /* Tam detay tuşu artık aksiyon yığınının ilk elemanı: ölçüsünü .pd-actions .btn
     kuralından alır, burada yalnız rengi tanımlanır. Gri ton, altındaki lacivert
     aksiyonlardan ayrışsın diye; renk sınıf yerine burada veriliyor çünkü
     custom.css .btn-secondary'yi !important ile laciverte çeviriyor.
     Ton, chip-gray ile aynı (#ECEFF3 / #4B5563). */
  .payment-history-modern .pd-full-link{
    background:#ECEFF3; border-color:#ECEFF3; color:#4B5563;
  }
  .payment-history-modern .pd-full-link:hover,
  .payment-history-modern .pd-full-link:focus{
    background:#dfe4ea; border-color:#dfe4ea; color:#4B5563;
  }
  /* Makbuz görüntüle + indir yan yana; dar panelde alt alta düşer. */
  .payment-history-modern .pd-receipt-actions{ display:flex; gap:.6rem; flex-wrap:wrap; }
  .payment-history-modern .pd-receipt-actions .btn{ flex:1 1 150px; }
  .payment-history-modern .pd-amount{
    font-size:1.75rem; font-weight:700; color:#1e293b; margin:.65rem 0 .15rem;
  }
  .payment-history-modern .pd-info-list{
    border:1px solid #eef1f5; border-radius:.85rem; padding:.35rem .85rem;
  }
  .payment-history-modern .pd-info-row{
    display:flex; align-items:center; justify-content:space-between; gap:.75rem;
    padding:.5rem 0; border-bottom:1px solid #f4f6f9;
  }
  .payment-history-modern .pd-info-row:last-child{ border-bottom:0; }
  .payment-history-modern .pd-info-label{ color:#8a94a6; font-size:.82rem; white-space:nowrap; }
  .payment-history-modern .pd-info-value{
    color:#1e293b; font-size:.85rem; font-weight:600; text-align:right;
  }
  .payment-history-modern .pd-fail-box{
    margin-top:1rem; padding:.75rem .9rem; border-radius:.85rem;
    background:#FDE2E2; color:#B42318;
  }
  .payment-history-modern .pd-fail-tech{
    margin-top:.5rem; padding-top:.5rem; border-top:1px dashed rgba(180,35,24,.35);
    font-size:.72rem; line-height:1.5; word-break:break-word; opacity:.9;
  }
  /* İşlem özeti kutusu — bilgi listesi ile aksiyonlar arasındaki boşlukta */
  .payment-history-modern .pd-summary{
    margin-top:1rem;
    padding:.9rem 1.05rem;
    border:1px solid #eef1f5;
    border-radius:.85rem;
    background:#fbfcfe;
  }
  .payment-history-modern .pd-summary-title{
    font-weight:700; color:#1e293b; font-size:.95rem; margin-bottom:.6rem;
  }
  .payment-history-modern .pd-summary-row{
    display:flex; align-items:center; justify-content:space-between;
    padding:.3rem 0; font-size:.85rem; color:#8a94a6;
  }
  .payment-history-modern .pd-summary-row span:last-child{ color:#1e293b; font-weight:600; }
  .payment-history-modern .pd-summary-total{
    margin-top:.35rem; padding-top:.6rem; border-top:1px solid #e6eaf0;
    color:#1e293b; font-weight:700;
  }
  .payment-history-modern .pd-summary-total span:last-child{ font-size:.95rem; }

  /* Aksiyonlar özetin hemen altında akışta yer alır (referanstaki gibi) */
  .payment-history-modern .pd-actions{
    display:flex; flex-direction:column; gap:.6rem; margin-top:1.15rem;
  }
  .payment-history-modern .pd-actions .btn{ height:44px; font-weight:600; }

  /* --- Detay paneli: xl altında sağdan açılan overlay --- */
  @media (max-width: 1199.98px){
    .payment-history-modern .ph-side{
      position:fixed; top:0; right:0; bottom:0;
      width:min(420px, 100%); z-index:1046; padding:0;
    }
    /* xl altı overlay: panel ekrana sabit olduğu için burada iç kaydırma şart. */
    .payment-history-modern .pd-panel{
      position:static; border-radius:0; height:100%; max-height:none; overflow:hidden;
    }
    .payment-history-modern .pd-panel-body{ overflow-y:auto; }
    .payment-history-modern .pd-backdrop{
      position:fixed; inset:0; background:rgba(15,23,42,.35); z-index:1045;
    }
  }
`;